import { render, staticRenderFns } from "./TpassDetailReturnHome.vue?vue&type=template&id=7d606a90&"
import script from "./TpassDetailReturnHome.vue?vue&type=script&lang=js&"
export * from "./TpassDetailReturnHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports